//
//  moodreels.ts
//  moods-film-ui-master
//
//  Created by romainharvier@gmail.com on 10/08/2019.
//  Copyright © 2019 Moods. All rights reserved.
//

import {Vue, Component, Prop} from 'vue-property-decorator';
import MoodsPageStyle from '@/components/moods-page-style/moods-page-style';

@Component({
    components: {
        MoodsPageStyle,
    },
})
export default class Moodreels extends Vue {

    @Prop(String) private readonly context!: string;

}
